// src/components/SignUpForm.tsx
import { useUser } from "@/context/useUser";
import { getTenantId } from "@/lib/storeManager";
import SignUpFormSchema from "@/schemas/SignupFormSchema";
import navigationRoutes from "@/utils/navigationRoutes";
import { FormItem, Input, Password, Submit } from "@formily/antd-v5";
import { createForm } from "@formily/core";
import { FormProvider, createSchemaField } from "@formily/react";
import { Card } from "antd";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const form = createForm({});

const SchemaField = createSchemaField({
  components: { FormItem, Input, Password },
});

const SignUpForm: React.FC = () => {
  const { signup, isAuthenticated } = useUser();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const tenantId = getTenantId() ?? "";

  const handleSubmit = async (values: {
    email: string;
    password: string;
    first_name: string;
    last_name: string;
  }) => {
    setLoading(true);
    const response = await signup(
      values.email,
      values.password,
      values.first_name,
      values.last_name
    );
    if (response) {
      navigate(navigationRoutes.SCHEMAS);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (isAuthenticated) {
      navigate(navigationRoutes.SCHEMAS);
    }
  }, [isAuthenticated, tenantId, navigate]);

  return (
    <Card title="Sign Up" className="w-full max-w-md rounded-xl shadow-xl">
      <FormProvider form={form}>
        <SchemaField schema={SignUpFormSchema} />
        <Submit
          onSubmit={handleSubmit}
          disabled={loading}
          className="w-full rounded-md px-4 py-2 text-white"
        >
          {loading ? "Signing Up ..." : "Sign Up"}
        </Submit>
      </FormProvider>
      <div className="mt-4 flex items-center justify-center">
        <div className="flex flex-col items-center">
          <span className="text-sm text-gray-500">
            Already have an account?
          </span>
          <Link to="/glucera/onboardingLoginpage" className="text-blue-500">
            Login
          </Link>
        </div>
      </div>
    </Card>
  );
};

export default SignUpForm;
